import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "gameshub-lock",
  "use": "gameshub-lock-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\" id=\"gameshub-lock\"><path d=\"M3.417 4.583V2.916a2.083 2.083 0 114.166 0v1.667m-5 0h5.834c.46 0 .833.373.833.833v2.917c0 .46-.373.833-.833.833H2.583a.833.833 0 01-.833-.833V5.416c0-.46.373-.833.833-.833z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/gameshub-lock.svg
// module id = UwBQ
// module chunks = 39 44